import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';

type SignInStatus = 'all' | 'signedIn' | 'signedOut';

@Component({
  selector: 'lib-sign-in-status-filter',
  standalone: true,
  template: `
    <div
      class="flex items-center bg-gray-100 rounded-lg border px-1 border-gray-200"
    >
      <button
        (click)="onFilterChange('all')"
        [class]="getButtonClass('all')"
        title="All"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="size-5"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M11.35 3.836c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75 2.25 2.25 0 0 0-.1-.664m-5.8 0A2.251 2.251 0 0 1 13.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m8.9-4.414c.376.023.75.05 1.124.08 1.131.094 1.976 1.057 1.976 2.192V16.5A2.25 2.25 0 0 1 18 18.75h-2.25m-7.5-10.5H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V18.75m-7.5-10.5h6.375c.621 0 1.125.504 1.125 1.125v9.375m-8.25-3 1.5 1.5 3-3.75"
          />
        </svg>

        <span class="ml-1 text-sm hidden sm:inline">All</span>
      </button>
      <button
        (click)="onFilterChange('signedIn')"
        [class]="getButtonClass('signedIn')"
        title="Signed In"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="size-6"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15M12 9l-3 3m0 0 3 3m-3-3h12.75"
          />
        </svg>

        <span class="ml-1 text-sm hidden sm:inline">Signed In</span>
      </button>
      <button
        (click)="onFilterChange('signedOut')"
        [class]="getButtonClass('signedOut')"
        title="Signed Out"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="size-5"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15m3 0 3-3m0 0-3-3m3 3H9"
          />
        </svg>

        <span class="ml-1 text-sm hidden sm:inline">Signed Out</span>
      </button>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SignInStatusFilterComponent {
  status = input.required<SignInStatus>();
  filterChange = output<SignInStatus>();

  onFilterChange(status: SignInStatus) {
    this.filterChange.emit(status);
  }

  getButtonClass(status: SignInStatus): string {
    const isActive = this.status() === status;
    const baseClasses =
      'flex items-center px-2 py-1.5 sm:px-3 sm:py-1.5 rounded-md text-sm font-medium transition-colors duration-150';

    if (isActive) {
      return `${baseClasses} bg-white text-gray-900 shadow-sm`;
    }

    return `${baseClasses} text-gray-600 hover:text-gray-900 hover:bg-gray-50`;
  }
}
